import api from '@/api/api';
import store from '../../store/store';

export const notificacaoService = {
  getCountNotificacoesPendente
}

function getCountNotificacoesPendente() {
  const { IdColaborador } = store.getters.user;
  return api.get(`notificacoes/${IdColaborador}?Acao=CountNotificacoesPendente`);
}